import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/awards/new/loading';

export const Route = createFileRoute('/_private/awards/new')({
  pendingComponent: Loading,
});
